import OperationalReportPage from './OperationalReportPage';
export default function CustomerRetentionReportPage(){return <OperationalReportPage kind="customer-retention"/>;}
